import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";
import { AdaptiveAuthenticationResult } from "@idw-types/data/adaptive-authentication-result/adaptive-authentication-result";

export const getAdaptiveAuthenticationResultsRequest = async (
    companyId: string,
    rpServiceId: string,
    workflowId: string,
    startDate: string,
    endDate: string,
    dateFormat: string
): Promise<{ data: Array<AdaptiveAuthenticationResult>, error: any }> => {
    const route = apiRoutes.reports.adaptiveAuthentication.results;
    const queryParameters: Array<QueryParameter> = [];

    if (rpServiceId) {
        queryParameters.push({ parameter: "rpAXNServiceID", value: rpServiceId });
    }
    if (companyId) {
        queryParameters.push({ parameter: "companyID", value: companyId });
    }
    if (workflowId) {
        queryParameters.push({ parameter: "workflowID", value: workflowId });
    }
    if (startDate) {
        queryParameters.push({ parameter: "startDate", value: startDate });
    }
    if (endDate) {
        queryParameters.push({ parameter: "endDate", value: endDate });
    }

    queryParameters.push({ parameter: "dateFormat", value: dateFormat })

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};